import {ResolveUsersIdentitiesArgs} from '~shared/schema/wiki/actions/users';

import {createThunk} from '~ui/store/utils';

export const resolveUsersIdentitiesThunk = createThunk(
    'users/resolve-users-identities',
    ({identities}: ResolveUsersIdentitiesArgs, {extra: {sdk}}) => {
        return sdk.wiki.resolveUsersIdentities({
            identities,
        });
    },
);
